import type { Attachment } from "@/admin/hooks/use-subject-attachments";

/**
 * A file filed against a record can be deleted or relabelled here. One that
 * is only referenced from a record's own fields (e.g. the Proof of Purchase
 * captured while registering) carries no subject, and the backend refuses to
 * change it through this card - so it lists read-only.
 */
export function isFiled(att: Pick<Attachment, "is_deleted" | "subject_type">): boolean {
  return !att.is_deleted && !!att.subject_type;
}
